<template>
    <div class="wrapper" :class="lang">
        <div class="header-wrapper">
            <div class="lang-wrapper" :style="'background-image: url('+headerBg+')'">
                <el-link :underline="false" :class="lang == 'simplified' ? 'current':'link'"
                         @click="changeLang('simplified')">简
                </el-link>
                <span class="lang-sep"></span>
                <el-link :underline="false" :class="lang == 'traditional' ? 'current':'link'"
                         @click="changeLang('traditional')">繁
                </el-link>
                <span class="lang-sep"></span>
                <el-link :underline="false" :class="lang == 'english' ? 'current':'link'"
                         @click="changeLang('english')">EN
                </el-link>
            </div>
            <div class="max">
                <div class="header">
                    <el-image :src="logo" class="logo"></el-image>
                    <div class="title-wrapper">
                        <div class="title" v-html="text.title"></div>
                        <div class="sub-title" v-html="text.subTitle" v-if="lang != 'english'"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="main-wrapper" :style="'background-image: url('+mainBg+')'">
            <div class="max">
                <img :src="main"/>
            </div>
            <div class="mask"></div>
        </div>

        <div class="main-title-wrapper">
            <div class="max">
                <div class="title">{{text.body.title}}</div>
                <div class="sub-title" v-html="text.body.subTitle"></div>
            </div>
        </div>

        <div class="body-wrapper">
            <div class="max body">
                <div class="declare" v-html="text.body.declare"></div>

                <div class="texts" :style="'height:'+(isShowMore?height+'px':'3.6rem')">
                    <div class="text-wrapper" ref="textWrapper">
                        <div class="text" v-for="(txt, idx) in text.body.texts" :key="idx" v-html="txt"></div>
                        <div class="btn-wrapper">
                            <div class="btn btn-less" @click="showLess">{{text.body.btnLess}}</div>
                        </div>
                    </div>

                    <div class="mask" v-if="!isShowMore">
                        <div class="btn btn-more" @click="showMore">{{text.body.btnMore}}</div>
                    </div>
                </div>

                <div class="product-title">{{text.body.productTitle}}</div>
                <div class="product-list">
                    <div class="product-item" v-for="(image, idx) in images" :key="idx">
                        <div class="image">
                            <el-image class="img" :src="image" fit="fill"></el-image>
                        </div>
                        <div class="name" v-html="text.body.products[idx]"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="right">© FU MUSIC 2025</div>
    </div>
</template>

<script>
    import logo from '@/assets/logo.png';
    import main from '@/assets/main.jpg';
    import mainBg from '@/assets/main-bg.jpg';
    import image00 from '@/assets/00.jpg';
    import image01 from '@/assets/01.jpg';
    import image02 from '@/assets/02.jpg';
    import image03 from '@/assets/03.jpg';
    import image04 from '@/assets/04.jpg';
    import image05 from '@/assets/05.jpg';
    import image06 from '@/assets/06.jpg';
    import image07 from '@/assets/07.jpg';
    import image08 from '@/assets/08.jpg';
    import image09 from '@/assets/09.jpg';
    import image10 from '@/assets/10.jpg';
    import image11 from '@/assets/11.jpg';
    import headerBg from '@/assets/pc-header-bg.png';

    export default {
        data() {
            return {
                logo: logo,
                main: main,
                mainBg: mainBg,
                images: [
                    image00, image01, image02, image03, image04, image05,
                    image06, image07, image08, image09, image10, image11,
                ],
                headerBg: headerBg,

                lang: 'simplified',
                isShowMore: false,
                height: 0,
                text: {},
                texts: {
                    simplified: {
                        title: '融合东西文化，创造全新观点',
                        subTitle: 'Coｍbining eastern and western cultures <br/> to create new and alternative perspectives.',
                        body: {
                            title: '「在千寻之外，我依然存在。」',
                            subTitle: '“Beyond a thousand horizons, still I remain.”',
                            declare: '关于生成式人工智能（「AI」）的声明——保留权利书／选择退出宣告',
                            texts: [
                                '在不损害任何先前权利保留的前提下，本司赋音乐有限公司（「赋音乐」）及方大同先生遗产管理方（「遗产管理方」），特此共同明确重申，我们完全保留下述所有权利。',
                                '我们特此重申：',
                                '未经赋音乐事先明确特别授权，严禁以任何方式（包括自动化手段）将赋音乐及／或遗产管理方拥有或控制的任何过往、现时或未来作品或内容（包括录音制品、视听录制品、音乐作品、歌词、艺术创作、姓名、肖像、形象、文字作品、数据、元数据等）（统称「赋音乐作品」）用于以下目的：复制、表演、传播、链结或摄取、机器学习或进行任何AI训练、AI系统或算法开发（无论是否具有商业性质）、或对前述AI系统、算法、工具或技术进行商业化运用、网络爬取、抓取、录制、改动、制作摘录或衍生作品、爬取、文本或数据开发或类似用途。禁止将任何赋音乐作品用于任何形式的文本与数据挖掘、AI训练、网络爬取、数据提取、改动或衍生作品创作。赋音乐发布的所有材料均受版权法／著作权法保护，无论明示或默认，均不获授权将其纳入用于训练或微调AI系统（包括但不限于机器学习算法、大型语言模型及其他用于生成或合成音乐、音频、文本或图像的AI系统）的数据库。',
                                '在缺乏明确事先授权许可上述使用的情况下，在法律允许的最大范围内，我们明确保留就赋音乐作品使用所享有之所有权利，包括但不限于依据欧盟指令2019/70/EC第4条（即使该等条文可能被解释为适用于上述用途，我们对此种解释不予认同）、香港《版权条例》（第528章）或全球任何司法管辖区类似法律所生之权利。此项权利保留适用于赋音乐及／或遗产管理方现时或未来拥有或控制之所有内容，包括可通过公开渠道识别之内容。',
                                '任何第三方必须获得赋音乐及／或遗产管理方以及其他权利持有人的明确许可，方可在任何机器学习或AI技术相关用途中使用方大同先生或与赋音乐相关之任何艺人及／或词曲作者的姓名、形象、肖像及／或声音。',
                                '本声明所述之权利保留适用于所有现存及未来之赋音乐作品，包括但不限于可通过公开渠道识别或不定时载于国际唱片业协会（IFPI）、香港作曲家及作词家协会（CASH）、香港音像联盟（HKRIA）等机构维护之数据库中的创作作品。',
                                '我们将采取必要措施以防止权利遭受侵害。',
                                '如欲将任何赋音乐作品用于AI相关用途，必须事先通过电子邮件 <a class="mail mail-pc" href="mailto:contact@fu-music.com">contact@fu-music.com</a> 与我们联系以取得授权。任何此类许可均可能按我们认为合适的条件授权，我们亦有权决定拒绝授权。',
                            ],

                            btnMore: '显示更多',
                            btnLess: '收起',

                            productTitle: '历年发行',
                            products: [
                                '2024.10.18<br/>梦想家',
                                '2022.08.07<br/>TWIOCAMIC',
                                '2022.04.14<br/>清楚点',
                                '2020.06.19<br/>宅这(EP)',
                                '2019.04.02<br/>白发',
                                '2018.12.26<br/>假行僧',
                                '2018.11.02<br/>云南里',
                                '2018.09.14<br/>Throw It Off',
                                '2018.07.27<br/>颂海(feat. 王诗安)',
                                '2018.03.13<br/>Ten Reasons',
                                '2016.09.28<br/>西游记',
                                '2014.04.11<br/>危险世界',
                            ],
                        }
                    },
                    english: {
                        title: 'Coｍbining eastern and western cultures <br/> to create new and alternative perspectives.',
                        subTitle: '',
                        body: {
                            title: '“Beyond a thousand horizons, still I remain.”',
                            subTitle: '',
                            declare: 'Statement regarding generative artificial intelligence (“AI”)<br/>- Reservation of Rights/Declaration of Opting Out',
                            texts: [
                                'Without prejudice to any prior rights reservations, we, Fu Music Limited (“Fu Music”) and the Estate of Khalil Fong (the “Estate”), hereby jointly expressly reaffirm that our rights are fully reserved as set out below.',
                                'We hereby reaffirm that:',
                                'Any past, present or future use of any of the works or content owned or controlled by Fu Music and/or the Estate (including recordings, audiovisual recordings, compositions, lyrics, artwork, names, likeness, images, literary works, data, metadata, etc.) (the “Fu Music Content”) for the purpose of reproducing, performing, distributing, linking to or ingesting, machine learning or any AI training, development of AI systems or algorithms (whether commercial or not), or commercialisation of the said AI systems or algorithms, tools or technology, web scraping, ripping, recording, altering, making extracts or derivatives, crawling, text or data mining or similar purposes, and by any means (including by automated means), is prohibited, except as specifically and explicitly authorized by Fu Music in advance. No Fu Music Content may be used for any form of text and data mining, AI training, web scraping, data extraction, alteration, or the creation of derivative works. All materials distributed by Fu Music are protected by copyright law and are not licensed—explicitly or implicitly—for inclusion in datasets used to train or fine-tune AI systems, including but not limited to machine learning algorithms, large language models, and other AI systems used to generate or synthesise music, audio, text, or images.',
                                'In the absence of an express advance licence permitting the above uses, we expressly reserve, to the fullest extent permitted by law, our rights in respect of the use the Fu Music Content, including without limitation under Article 4 of the EU Directive 2019/70/EC (to the extent that this Article would apply to the above uses, an interpretation we do not agree with), the Copyright Ordinance of Hong Kong (Cap. 528) or similar laws in other jurisdictions worldwide. Our reservation applies to all content owned or controlled by Fu Music and/or the Estate, now or in the future, including where this content may be identified through publicly available means.',
                                'All parties must obtain an express license from Fu Music and/or the Estate and any other rights holders to use the name, image, likeness, and/or voice of the late Mr. Khalil Fong, or any artists and/or songwriters associated with Fu Music, in connection with any machine learning or AI technologies.',
                                'The rights reservation under this statement apply to all existing and future Fu Music Content, including but not limited to creative works that may be identified through publicly available means or listed from time to time in databases such as those maintained by the International Federation of the Phonographic Industry (IFPI), Composers and Authors Society of Hong Kong Limited (CASH), Hong Kong Recording Industry Alliance Limited (HKRIA). ',
                                'We will take the necessary steps to prevent the infringement of our rights.',
                                'If you want to use any Fu Music Content for any AI purpose, you must contact us in advance to request a license by email at <a class="mail mail-pc-english" href="mailto:contact@fu-music.com">contact@fu-music.com</a>. Any such license may be granted under any condition as we may see fit, or withheld or denied in our sole discretion.',
                            ],

                            btnMore: 'Show More',
                            btnLess: 'Show Less',

                            productTitle: 'Releases',
                            products: [
                                '2024.10.18<br/>The Dreamer',
                                '2022.08.07<br/>TWIOCAMIC',
                                '2022.04.14<br/>Look Closer',
                                '2020.06.19<br/>Home Sweet Home(EP)',
                                '2019.04.02<br/>White Hair',
                                '2018.12.26<br/>Fake Monk',
                                '2018.11.02<br/>Yun Nan Li',
                                '2018.09.14<br/>Throw It Off',
                                '2018.07.27<br/>Dear Ocean(feat. 王詩安)',
                                '2018.03.13<br/>Ten Reasons',
                                '2016.09.28<br/>JTW',
                                '2014.04.11<br/>Dangerous World',
                            ],
                        }
                    },
                    traditional: {
                        title: '融合東西文化，創造全新觀點',
                        subTitle: 'Coｍbining eastern and western cultures <br/> to create new and alternative perspectives.',
                        body: {
                            title: '「在千尋之外，我依然存在。」',
                            subTitle: '“Beyond a thousand horizons, still I remain.”',
                            declare: '關於生成式人工智能（「AI」）的聲明——保留權利書／選擇退出宣告',
                            texts: [
                                '在不損害任何先前權利保留的前提下，本司賦音樂有限公司（「賦音樂」）及方大同先生遺產管理方（「遺產管理方」），特此共同明確重申，我們完全保留下述所有權利。',
                                '我們特此重申：',
                                '未經賦音樂事先明確特別授權，嚴禁以任何方式（包括自動化手段）將賦音樂及／或遺產管理方擁有或控制的任何過往、現時或未來作品或內容（包括錄音製品、視聽錄製品、音樂作品、歌詞、藝術創作、姓名、肖像、形象、文字作品、數據、元數據等）（統稱「賦音樂作品」）用於以下目的：複製、表演、傳播、鏈結或攝取、機器學習或進行任何AI訓練、AI系統或算法開發（無論是否具有商業性質）、或對前述AI系統、算法、工具或技術進行商業化運用、網絡爬取、抓取、錄製、改動、製作摘錄或衍生作品、爬取、文本或數據開發或類似用途。禁止將任何賦音樂作品用於任何形式的文本與數據挖掘、AI訓練、網絡爬取、數據提取、改動或衍生作品創作。賦音樂發布的所有材料均受版權法／著作權法保護，無論明示或默示，均不獲授權將其納入用於訓練或微調AI系統（包括但不限於機器學習算法、大型語言模型及其他用於生成或合成音樂、音頻、文本或圖像的AI系統）的數據庫。',
                                '在缺乏明確事先授權許可上述使用的情況下，在法律允許的最大範圍內，我們明確保留就賦音樂作品使用所享有之所有權利，包括但不限於依據歐盟指令2019/70/EC第4條（即使該等條文可能被解釋為適用於上述用途，我們對此種解釋不予認同）、香港《版權條例》（第528章）或全球任何司法管轄區類似法律所生之權利。此項權利保留適用於賦音樂及／或遺產管理方現時或未來擁有或控制之所有內容，包括可通過公開渠道識別之內容。',
                                '任何第三方必須獲得賦音樂及／或遺產管理方以及其他權利持有人的明確許可，方可在任何機器學習或AI技術相關用途中使用方大同先生或與賦音樂相關之任何藝人及／或詞曲作者的姓名、形象、肖像及／或聲音。',
                                '本聲明所述之權利保留適用於所有現存及未來之賦音樂作品，包括但不限於可通過公開渠道識別或不定時載於國際唱片業協會（IFPI）、香港作曲家及作詞家協會（CASH）、香港音像聯盟（HKRIA）等機構維護之數據庫中的創作作品。',
                                '採取必要措施以防止權利遭受侵害。',
                                '如欲將任何賦音樂作品用於AI相關用途，必須事先透過電子郵件 <a class="mail mail-pc" href="mailto:contact@fu-music.com">contact@fu-music.com</a> 與我們聯繫以取得授權。任何此類許可均可能按我們認為合適的條件授權，我們亦有權決定拒絕授權。',
                            ],

                            btnMore: '顯示更多',
                            btnLess: '收起',

                            productTitle: '歷年發行',
                            products: [
                                '2024.10.18<br/>夢想家',
                                '2022.08.07<br/>TWIOCAMIC',
                                '2022.04.14<br/>清楚點',
                                '2020.06.19<br/>宅這(EP)',
                                '2019.04.02<br/>白髮',
                                '2018.12.26<br/>假行僧',
                                '2018.11.02<br/>雲南裡',
                                '2018.09.14<br/>Throw It Off',
                                '2018.07.27<br/>頌海（feat. 王詩安)',
                                '2018.03.13<br/>Ten Reasons',
                                '2016.09.28<br/>西遊記',
                                '2014.04.11<br/>危險世界',
                            ],
                        }

                    }
                }
            }
        },

        beforeMount() {
            const lang = window.navigator.language.toLowerCase();
            if (lang == 'zh-cn') {
                this.lang = 'simplified';
            } else if (lang == 'zh-tw') {
                this.lang = 'traditional';
            } else {
                this.lang = 'english';
            }
            this.text = this.texts[this.lang];
        },
        mounted() {
            window.addEventListener('orientationchange', () => {
                setTimeout(() => {
                    this.height = this.$refs.textWrapper.offsetHeight;
                }, 50)
            });
        },
        methods: {
            changeLang(lang) {
                if (this.lang == lang) {
                    return;
                }

                this.lang = lang
                this.text = this.texts[lang];
                this.$nextTick(() => {
                    this.height = this.$refs.textWrapper.offsetHeight;
                })
            },
            showMore() {
                this.isShowMore = true;
                this.height = this.$refs.textWrapper.offsetHeight;
            },
            showLess() {
                this.isShowMore = false;
            },
        }
    }
</script>


<style scoped lang="less">
    .max {
        max-width: 19.2rem;
        height: auto;
        margin-left: auto;
        margin-right: auto;
    }

    .right {
        text-align: center;
        font-size: 0.2rem;
        color: #FFF;
        margin-top: 1rem;
        margin-bottom: 0.5rem;
    }

    .header-wrapper {
        width: 100%;
        height: 3rem;
        background-color: #fff;
        display: flex;
        flex-direction: column;

        .lang-wrapper {
            color: #bcbcbc;
            text-align: right;
            padding: 0.1rem 1rem  0.4rem 1rem;
            width: 100%;
            box-sizing: border-box;
            caret-color: transparent;
            background-repeat: no-repeat;
            background-position: bottom center;
            background-size: 100% auto;

            .lang-sep {
                width: 0.2rem;
                display: inline-block;
            }

            .current {
                color: #000;
            }

            .link {
                color: #bcbcbc;
            }
        }

        .max {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
        }

        .header {
            width: 100%;
            align-items: center;
            gap: 0.1rem;
            display: flex;


            .logo {
                width: 0.94rem;
                height: 0.94rem;
                display: inline-block;
            }

            .title-wrapper {
                color: #000;
                text-align: center;
                width: 5rem;
                padding-bottom: 0.1rem;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .title {
                    font-size: 0.35rem;
                    line-height: 0.4rem;
                    font-family: 'sye';
                    vertical-align: top;
                }

                .sub-title {
                    font-size: 0.22rem;
                    line-height: 0.26rem;
                    font-family: 'sye';
                    margin-top: 0.05rem;
                }
            }
        }
    }

    .main-wrapper {
        width: 100%;
        height: auto;
        background-size: auto 100%;
        background-repeat: repeat-x;
        position: relative;

        img {
            display: block;
            width: 100%;
            height: auto;
        }

        .mask {
            width: 100%;
            height: 100%;
            background-image: linear-gradient(to top, rgba(0, 0, 0, 0.88) 0%, rgba(0, 0, 0, 0.5) 15%, transparent 50%, transparent 100%);
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
        }
    }

    .main-title-wrapper {
        position: relative;
        top: -2.7rem;
        width: 100%;
        height: 0;
        color: #FFF;
        text-align: center;

        .title {
            font-size: 0.72rem;
            text-align: center;
            letter-spacing: 0.1rem;
            font-family: 'sye';
        }

        .sub-title {
            font-size: 0.40rem;
            text-align: center;
            margin-top: 0.1rem;
            font-family: 'sye';
        }
    }

    .body-wrapper {
        width: 100%;

        .body {
            color: #FFF;
            max-width: 12rem;

            .declare {
                font-size: 0.3rem;
                text-align: center;
                margin-top: 0.3rem;
                margin-bottom: 0.35rem;
                font-weight: 500;
                font-family: 'sye';
            }

            .texts {
                width: 100%;
                height: 3.6rem;
                overflow: hidden;
                position: relative;
                transition: height 2s ease;

                .mask {
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    width: 100%;
                    height: 1.5rem;
                    background-image: linear-gradient(to top, rgba(0, 0, 0, 0.88) 0%, transparent 100%);
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-end;
                }

            }

            .text-less {
                height: 3.6rem;
                overflow: hidden;
            }

            .text-more {
            }

            .text {
                font-size: 0.22rem;
                line-height: 1.5;
                margin-top: 0.35rem;
                text-align: justify;
            }

            .btn {
                font-size: 0.24rem;
                height: 0.6rem;
                border-radius: 0.3rem;
                border: 0.02rem solid #FFF;
                color: #FFF;
                background-color: #393939;
                margin-left: auto;
                margin-right: auto;
                text-align: center;
                line-height: 0.6rem;
                cursor: pointer;
                caret-color: transparent;
            }

            .btn:hover {
                color: #393939;
                background-color: #bcbcbc;
            }

            .btn-more {
                width: 5rem;
            }

            .btn-wrapper {
                padding-top: 1rem;
                padding-bottom: 0.5rem;
            }

            .btn-less {
                width: 2rem;
            }

            .product-title {
                margin-top: 1rem;
                font-size: 0.32rem;
                line-height: 0.5rem;
                color: #FFF;
                border-bottom: 0.02rem solid #fff;
            }

            .product-list {
                margin-top: 0.6rem;
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                gap: 0.45rem;
                justify-content: space-between;

                .product-item {
                    flex-shrink: 0;
                    width: 2.4rem;

                    .image {
                        width: 2.4rem;
                        height: 2.4rem;
                        border-radius: 0.05rem;
                        overflow: hidden;

                        .img {
                            width: 100%;
                            height: 100%;
                            transition: transform 0.3s ease;
                        }

                        .img:hover {
                            transform: scale(1.1);
                        }
                    }

                    .name {
                        font-size: 0.21rem;
                        text-align: center;
                        line-height: 0.3rem;
                        margin-top: 0.1rem;
                    }
                }
            }
        }
    }

    .english {
        .header-wrapper {
            .header {
                align-items: center;

                .title-wrapper {
                    .title {
                        font-size: 0.24rem;
                        line-height: 0.26rem;
                        padding-bottom: 0.15rem;
                        box-sizing: border-box;
                        text-align:left;
                    }
                }
            }
        }

        .main-title-wrapper {
            .title {
                font-size: 0.58rem;
                letter-spacing: 0 !important;
            }
        }

        .body-wrapper {
            .body {
                .declare {
                    font-size: 0.32rem;
                }

                .text {
                    font-size: 0.24rem;
                }
            }
        }
    }


    @media screen and (min-width: 1024px) and (max-width: 1280px) {
        .max {
            max-width: 10rem !important;
        }

        .lang-wrapper {
            padding: 0.1rem 0.6rem 0.4rem 0.6rem !important;
        }

        .main-title-wrapper {
            top: -1.6rem !important;

            .title {
                font-size: 0.6rem !important;
            }

            .sub-title {
                font-size: 0.3rem !important;
            }
        }

        .body {
            max-width: 9rem !important;

            .declare {
                font-size: 0.28rem !important;
            }
        }
    }

    @media screen and (min-width: 800px) and (max-width: 1024px) {
        .max {
            max-width: 8rem !important;
        }

        .lang-wrapper {
            padding: 0.1rem 0.3rem  0.4rem 0.3rem !important;
        }

        .main-title-wrapper {
            top: -1.2rem !important;

            .title {
                font-size: 0.4rem !important;
            }

            .sub-title {
                font-size: 0.26rem !important;
            }
        }

        .body {
            max-width: 7.6rem !important;

            .declare {
                font-size: 0.22rem !important;
            }

            .text {
                font-size: 0.18rem !important;
            }

            .product-list {
                .product-item {
                    width: 2.2rem !important;
                }
            }
        }
    }

    @media screen and (max-width: 800px) {
        .max {
            max-width: 7.6rem !important;
        }

        .lang-wrapper {
            padding: 0.1rem 0.2rem  0.4rem 0.2rem !important;
        }

        .main-title-wrapper {
            top: -1rem !important;

            .title {
                font-size: 0.36rem !important;
            }

            .sub-title {
                font-size: 0.22rem !important;
            }
        }

        .body {
            max-width: 7.2rem !important;

            .declare {
                font-size: 0.22rem !important;
            }

            .text {
                font-size: 0.18rem !important;
            }

            .product-list {
                .product-item {
                    width: 2rem !important;

                    .name {
                        font-size: 0.17rem !important;
                        line-height: 0.22rem !important;
                    }
                }
            }
        }
    }

</style>
